import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { TextField } from '../textfield.js';
import GeneralModal from './GeneralModal/general-modal.js';

const PaymentDetailsModal = ({
	open,
	onClose,
	paymentDetails,
	isMobile
}) => (
	<GeneralModal
		showCloseIcon={true}
		open={open}
		onClose={() => {
			onClose();
		}}
		genText={'Payment to be Collected from Recipients'}
		genTextClassName={'medium1'}
		no2btn={true}
		maxHeight={'400px'}
		width={isMobile ? '90%' : '484px'}
	>
		<>
			{paymentDetails?.additionalamount > 0 && (
				<InfoRow label='Additional Charges' value={`₹ ${paymentDetails.additionalamount}`} />
			)}
			{paymentDetails?.stampAmount && (
				<InfoRow label='Stamp Amount' value={`₹ ${paymentDetails.stampAmount}`} />
			)}
			{paymentDetails?.recipientName && (
				<InfoRow label='Recipient Name' value={paymentDetails.recipientName} />
			)}
			{paymentDetails?.description && (
				<InfoRow
					label='Description'
					value={paymentDetails.description}
					isTextArea={true}
					textAreaHeight='80px'
				/>
			)}
		</>
	</GeneralModal>
);

const InfoRow = ({ label, value, isTextArea = false, textAreaHeight }) => (
	<Box
		display='flex'
		width='100%'
		justifyContent='space-between'
		marginTop='10px'
		sx={{ alignItems: 'center' }}
	>
		<Box width='calc(50% - 15px)' marginRight='15px'>
			<Typography className='medium6'>{label}</Typography>
		</Box>
		<Box width='calc(50% - 15px)'>
			<TextField
				value={value}
				labelClassName='medium6'
				width='100%'
				height='40px'
				removeImageLeftBorder={true}
				borderColor='#ECF0E5'
				disabled
				textArea={isTextArea}
				textAreaHeight={textAreaHeight}
			/>
		</Box>
	</Box>
);

PaymentDetailsModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	paymentDetails: PropTypes.shape({
		additionalamount: PropTypes.number,
		stampAmount: PropTypes.number,
		recipientName: PropTypes.string,
		description: PropTypes.string
	}).isRequired,
	isMobile: PropTypes.bool.isRequired
};

InfoRow.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	isTextArea: PropTypes.bool,
	textAreaHeight: PropTypes.string
};

export default PaymentDetailsModal;
